module.exports = __webpack_public_path__ + "img/nav-user-switch.9d91387e.svg";